import styled, { css } from 'styled-components'

export const CheckoutSection = styled.section`
  padding: 60px 0;
`

export const Wrapper = styled.div`
  max-width: 1360px;
  margin: 0 auto;
  position: relative;
  width: 100%;

  @media (max-width: 1390px) {
    max-width: 95%;
  }

  @media (max-width: 1170px) {
    .col-pagamento,
    .col-envio,
    .col-confirmacao,
    .col-cotacao,
    .col-negociacao {
      .col-3 {
        width: 35%;
        float: left;
      }

      .col-9 {
        width: 65%;
        float: left;
      }
    }
  }

  @media (max-width: 1170px) {
    .col-confirmacao {
      .col-6 {
        width: 100%;

        &:first-child {
          padding-right: 0px;
        }

        &:nth-child(2) {
          padding-left: 0px;
        }
      }
    }
  }

  @media (max-width: 800px) {
    .col-pagamento,
    .col-envio,
    .col-confirmacao {
      .col-3 {
        z-index: 199;
        width: 100%;
        float: left;
      }

      .col-9 {
        width: 100%;
        float: left;
      }
    }
  }

  @media (max-width: 900px) {
    .col-cotacao,
    .col-negociacao {
      .col-3 {
        z-index: 199;
        width: 100%;
        float: left;
      }

      .col-9 {
        width: 100%;
        float: left;
      }
    }
  }
`

export const PageTitle = styled.h2`
  font-size: 22px;
  font-weight: 500;
  margin-bottom: 10px;
`

export const PageContent = styled.div`
  @media (max-width: 800px) {
    margin-bottom: 110px;
  }
`

export const Tributacao = styled.div`
  padding: 0;
  /* background-color: tomato; */

  .content-section {
    /* background-color: blue; */
  }

  .title-tooltip {
    h3 {
      position: relative;
      display: inline-block;
    }
  }

  .tributacao {
    margin-top: 12px;

    p {
      margin-bottom: 16px;
      margin-top: 8px;
      font-size: 15px;
      padding-right: 8px;
    }

    div {
      &:first-child {
        display: flex;
        align-items: center;
      }

      strong {
        font-size: 14px;
        margin-right: 8px;
      }

      label {
        margin-left: 8px;
      }
    }
  }

  .cards {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
`

export const ColGroup = styled.div`
  .col-3 {
    width: 30%;
  }

  .col-9 {
    width: 70%;
  }

  .col-6 {
    padding: 0;

    &:first-child {
      padding-right: 8px;
    }

    &:nth-child(2) {
      padding-left: 10px;
    }
  }

  .col-resumo {
    position: sticky;
    top: 20px;
    /* right: 0; */
  }

  .col-cotacao {
    @media (max-width: 800px) {
      display: none;
    }
  }

  .col-resumo-confirmacao {
    position: sticky;
    top: 20px;

    @media (max-width: 800px) {
      display: none;
    }
  }

  .col-resumo-cotacao {
    position: sticky;
    top: 20px;

    @media (max-width: 800px) {
      /* display: none; */
    }
  }

  @media (max-width: 1170px) {
    .col-3 {
      width: 100%;
    }

    .col-9 {
      width: 100%;
    }
    .col-6 {
      width: 50%;
      padding: 0;
      display: inline-block;
    }
  }

  @media (max-width: 700px) {
    .col-6 {
      width: 100%;
      padding: 0;
      display: block;

      &:first-child {
        padding-right: 0px;
      }

      &:nth-child(2) {
        padding-left: 0px;
      }
    }
  }
`

export const CardBox = styled.div`
  background: #ffffff;
  padding: 10px;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  -webkit-box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1);
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
`
export const Button = styled.button`
  ${({ theme, outline }) => css`
    border-radius: 4px;
    border: 2px solid transparent;
    font-family: 'Montserrat', sans-serif;
    font-weight: 500;
    font-size: 16px;
    padding: 12px 30px;
    margin-bottom: 10px;
    width: 100%;
    text-align: center;
    transition: ${theme.transition.default};
    cursor: pointer;
    background: ${theme.colors.primary};
    color: ${theme.colors.white};

    &:hover {
      background: #a71e26;
    }

    & + .button {
      margin-left: 15px;
    }

    @media (max-width: $MEDIA-IPAD) {
      font-size: 14px;
    }

    &.button-outline {
      background: transparent;
      border: 2px solid ${theme.colors.primary};
      color: ${theme.colors.primary};

      &:hover {
        border-color: #4a4a4a;
        color: #4a4a4a;
      }

      &:disabled {
        color: #7b7b7b;
        border-color: #7b7b7b;
        cursor: initial;
      }
    }

    ${!!outline &&
    css`
      background: transparent;
      border: 2px solid ${theme.colors.primary};
      color: ${theme.colors.primary};
      cursor: pointer;

      &:hover {
        border-color: #4a4a4a;
        color: #4a4a4a;
        background: #fff;
      }
    `}

    @media (max-width: 1170px) {
      & + .button {
        margin-left: 0;
        margin-top: 8px;
      }
    }
  `}
`
